import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap"
import { IconButton } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import TemplateDoc from '../../../templates/sBook/Mantainers/tmp_Projects.csv'
import { addProject, addProjectList, deleteProject, getProjectById, saveProjectById } from "../../../services/sBook/project.service";
import { useGetProjectsMaintainer } from "../../../hooks/services/sBook/useOfProject";
import ProfileVerify from "../../../components/Templates/Site/ProfileVerify";
import MessageBox from "../../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../../common/Dictionaries";
import { getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../../common/Helpers";
import MainAppContext from "../../../MainAppContext";
import MatrixToolbar from "../../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, removeGridLocalStorageFilters, setterActionFired, useFilterActionComponentData } from "../../../common/Helpers/JqxGridFilter";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function Project(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [listProjects, setListProjects] = useState(null);
    useGetProjectsMaintainer(listProjects, setListProjects)

    useFilterActionComponentData(gridRef, messageConfig, "Project");

    useEffect(() => {
        if (listProjects === null) {
            removeGridLocalStorageFilters("Project")
        }

    }, [listProjects]);

    //Funciones de componente.
    const isValidFormControls = (list) => {
        let isValidForm = true;

        list.forEach(element => {
            if (element.name === '' || element.name === null || element.name === undefined) {
                isValidForm = false;
            }

            let aux_coincidences = list.filter(x => x.id !== element.id && x.name === element.name);

            if (aux_coincidences !== null && aux_coincidences !== undefined) {
                if (aux_coincidences.length > 0) {
                    isValidForm = false;
                }
            }
        });
    
        return isValidForm;
    }

    const handlerAddNewRow = (obj) => {
        const _lowerId = listProjects.length > 0 ? listProjects.reduce((min, obj) => obj.id < min ? obj.id : min, listProjects[0].id) : 0;
        const lowerId = listProjects.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id:               lowerId,
            name:             "",
            projectCode: "",
        } : {
            id:               lowerId,
            name:             obj.name,
            projectCode:      obj.projectCode,
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listProjects.unshift(newRow);
        setListProjects(listProjects);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("Project", 1)
    };

    const handlerUploadData = () => {
        fileInputRef.current.click();
    };

    const handlerFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                row.forEach((cell, columnIndex) => {
                    const columnName = getColumns().find(x => x.index === columnIndex).dataField;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listProjects.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                getColumns().forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: getColumns().filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'Project_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'Project_UploadTemplate.xlsx');
        }
    };

    const handlerSaveAll = () => {
        //Obtener todos los elementos con id <= 0, ya que estos son los elementos a agregar.
        const aux_list = listProjects.filter(x => x.id <= 0);
        
        //Validar cada elemento, que el name no este blanco.
        const frmIsValid = isValidFormControls(aux_list);

        if (frmIsValid === true) {
            addProjectList(aux_list).then((response) => {
                //Luego de enviar a guardar, los elementos que se devuelvan deben ser actualizados en el listado local. Se devolvera un arreglo con id Old (negativo) y nueva id (id guardada)
                let aux_failedItems = response.data.filter(x => !x.succeeded)
                let aux_correctItems = response.data.filter(x => x.succeeded)
                let hasError = false

                if (aux_failedItems !== null && aux_failedItems !== undefined) {
                    if (aux_failedItems.length > 0) {
                        hasError = true
                    }
                }

                /*let rowCells = null;
                let invalidTextbox = null;

                response.data.forEach(element => {
                    if (element.succeeded) {
                        for (let index = 0; index < listProjects.length; index++) {
                            if (listProjects[index].id === parseInt(element.message)) {

                                rowCells = document.getElementsByClassName("rowEdit" + listProjects[index].id);
                                for (let index = 0; index < rowCells.length; index++) {
                                    let rowCell = rowCells[index];
                                    rowCell.parentNode.parentNode.parentNode.setAttribute("style", "background-color: white")
                                }

                                invalidTextbox = document.getElementById("invalidTextbox" + listProjects[index].id);
                                invalidTextbox.setAttribute("style", "display: block")

                                listProjects[index].id = element.data.id;
                                listProjects[index].projectCode = element.data.projectCode;
                            }
                        }

                        setListProjects(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: listProjects
                        }));
                    }

                    if (!element.succeeded) {
                        let actualItem = listProjects.find(x => x.id === parseInt(element.data.id))
                        rowCells = document.getElementsByClassName("rowEdit" + actualItem.id);
                        invalidTextbox = document.getElementById("invalidTextbox" + actualItem.id);

                        invalidTextbox.setAttribute("style", "display: block")

                        for (let index = 0; index < rowCells.length; index++) {
                            let rowCell = rowCells[index];
                            rowCell.parentNode.parentNode.parentNode.setAttribute("style", "background-color: #fde7e9")
                        }
                    } 
                });*/

                if (hasError) {
                    if (aux_correctItems) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationpartialerror'))
                    } else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }
                else {
                    setListProjects(null)
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }    
                setterActionFired("Project", 1);
            }).catch((err) => {
                //De haber falla se devolvera arreglo con ID (en negativo) y la razon de la falla.
                //Se deben gatillar los errores de los que no pudieron ser guardados.
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Project", 1)
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setterActionFired("Project", 1)
        }
    };

    const handlerSave = async (itemId) => {
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);
        
        if (validateObject(item)) {
            if (item.id <= 0) {
                item.projectNemo = "";

                await addProject(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))

                        listProjects.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.projectCode = serviceResponse.data.data.projectCode;
                            }
                        });

                        setListProjects(listProjects);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed')) 
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }        
                    setterActionFired("Project", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("Project", 1)
                });
            }
            else {
                saveProjectById(itemId, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }  
                    setterActionFired("Project", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("Project", 1)
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListProjects = listProjects.filter(x => x.id !== itemId);
            setListProjects(newListProjects)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("Project", 1)
        }
        else {
            await deleteProject(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListProjects = listProjects.filter(x => x.id !== itemId);
                    setListProjects(newListProjects)
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("Project", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Project", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListProject = listProjects.filter(x => x.id !== itemId);
            setListProjects(newListProject)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("Project", 1)
        }
        else
        {
            await getProjectById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listProjects.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    setListProjects(listProjects);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("Project", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("Project", 1)
            });
        }
    };

    const validateObject = (object) => {
        const isValid = object.name !== undefined && object.name !== null && object.name !== '';

        return isValid;
    };

    const getColumns = () => {
        const basicColumns = [
            { index: null, text: 'ID',                                  dataField: 'id',              uploadMasive: false, exportable: false, width: '0px',   columntype: 'textbox', editable: false, hidden: true },
            { index: null, text: t('data-lang-lbl-actions'),            dataField: 'acciones',        uploadMasive: false, exportable: false, width: '5%', pinned: true,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: null, text: t('data-lang-lbl-code'),               dataField: 'projectCode',     uploadMasive: false, exportable: true,  width: '10%', columntype: 'textbox', editable: false, pinned: true },
            { index: 0,    text: t('data-lang-lbl-name'),               dataField: 'name',            uploadMasive: true,  exportable: true,  width: '85%', createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null,                   'textbox', 'string'), columntype: 'textbox',        cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'),       editable: profileHasAccess, pinned: true },
        ]

        return basicColumns;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listProjects[rowIndex.boundindex].id;
        }
        return listProjects[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            listProjects[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            listProjects[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listContracts = JSON.parse(JSON.stringify(listProjects));
        setListProjects(copia_listContracts);

        if (editingRows.find(x => x === listProjects[e.args.rowindex].id) === undefined) {
            editingRows.push(listProjects[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'Project', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);
        const rowIndex = 0;
        return  <>
                {
                    profileHasAccess &&
                    <>
                        {isEditing ? (
                            <>
                                {
                                    itemId <= 0 ? (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    ) : (
                                        <>
                                            <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                            <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                        </>
                                    )
                                }
                            </>
                        ) : (
                            <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                        )}
                    </>
                }
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId)
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
                case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
            default:
                break;
        }
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-projects')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">
                            <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handlerFileUpload} />
                            <a id="btnGetTemplate" href={TemplateDoc} download="ContractTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listProjects &&
                            <>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={handlerSaveAll}
                                    inputParam_HandleUploadData={handlerUploadData}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNewRow}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showRowButtons: profileHasAccess,
                                            showExportData: true,
                                            showAddMasiveData: profileHasAccess,
                                            showAddData: profileHasAccess,
                                            showDownloadTemplate: profileHasAccess,
                                            showSaveAllData: profileHasAccess,
                                            groupedButtons: profileHasAccess
                                        },
                                        handlers: {
                                            handlerSave: profileHasAccess ? handlerSave : null,
                                            handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: profileHasAccess ? handlerCancel : null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[
                                        {
                                            id: 'btnMantGetTemplate',
                                            key: 'btnMantGetTemplate',
                                            text: t('data-lang-lbl-uploadtemplate'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => handlerExportData(false)
                                        }
                                    ]}
                                    inputParam_CustomOpenPanel={false}
                                    showRequiredMessage={showRequiredGlobalMessage}
                                />
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    height={'500px'}
                                    editable={true}
                                    //pageable={true}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listProjects,
                                        dataType: 'array',
                                        dataFields: [
                                            { name: 'id',          type: 'number' },
                                            { name: 'projectCode', type: 'string' },
                                            { name: 'name',        type: 'string' },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged} 
                                    onFilter={(event) => handlerFilter(event, 'Project')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}